export default {
  getRoles: () => `/employee-role`,
};
